import React from 'react';
import {Modal, ModalOverlayProps} from '@mantine/core';

export const EtroModalOverlay: React.FC<ModalOverlayProps> = props => {
  return <Modal.Overlay {...props} />;
};
